import React from 'react';
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from './components/ui/sonner';

import Layout from './components/layout/Layout';
import HomePage from './components/pages/HomePage';
import { ServicesPage, ServiceDetailPage, SubServicePage } from './components/pages/ServicesPage';
import { ZonesPage, ZoneDetailPage } from './components/pages/ZonesPage';
import AboutPage from './components/pages/AboutPage';
import ContactPage from './components/pages/ContactPage';
import LegalPage from './components/pages/LegalPage';

// Plateforme
import { AuthProvider } from './platform/AuthContext';
import ProtectedRoute from './platform/ProtectedRoute';
import LoginPage from './platform/pages/LoginPage';
import ForgotPasswordPage from './platform/pages/ForgotPasswordPage';
import ResetPasswordPage from './platform/pages/ResetPasswordPage';
import AdminLayout from './platform/layouts/AdminLayout';
import ClientLayout from './platform/layouts/ClientLayout';
import AdminAgenda from './platform/admin/AdminAgenda';
import AdminDashboard from './platform/admin/AdminDashboard';
import AdminClients from './platform/admin/AdminClients';
import AdminClientDetail from './platform/admin/AdminClientDetail';
import AdminInterventions from './platform/admin/AdminInterventions';
import AdminInterventionDetail from './platform/admin/AdminInterventionDetail';
import AdminContactRequests from './platform/admin/AdminContactRequests';
import ChangePasswordForm from './platform/components/ChangePasswordForm';
import ClientDashboard from './platform/client/ClientDashboard';
import ClientNewRequest from './platform/client/ClientNewRequest';
import ClientRequestDetail from './platform/client/ClientRequestDetail';

const PublicSite = () => (
  <Layout>
    <Routes>
      <Route path="/" element={<HomePage />} />
      <Route path="/services" element={<ServicesPage />} />
      <Route path="/services/:serviceId" element={<ServiceDetailPage />} />
      <Route path="/services/:serviceId/:subServiceId" element={<SubServicePage />} />
      <Route path="/zones" element={<ZonesPage />} />
      <Route path="/zones/:cityId" element={<ZoneDetailPage />} />
      <Route path="/a-propos" element={<AboutPage />} />
      <Route path="/contact" element={<ContactPage />} />
      <Route path="/mentions-legales" element={<LegalPage />} />
      <Route path="/politique-confidentialite" element={<LegalPage />} />
    </Routes>
  </Layout>
);

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            {/* Authentification */}
            <Route path="/connexion" element={<LoginPage />} />
            <Route path="/mot-de-passe-oublie" element={<ForgotPasswordPage />} />
            <Route path="/reinitialiser-mot-de-passe" element={<ResetPasswordPage mode="reset" />} />
            <Route path="/activer-compte" element={<ResetPasswordPage mode="activate" />} />

            {/* Espace Administrateur */}
            <Route path="/admin" element={<ProtectedRoute allow={['admin']}><AdminLayout /></ProtectedRoute>}>
              <Route index element={<AdminAgenda />} />
              <Route path="stats" element={<AdminDashboard />} />
              <Route path="clients" element={<AdminClients />} />
              <Route path="clients/:clientId" element={<AdminClientDetail />} />
              <Route path="interventions" element={<AdminInterventions />} />
              <Route path="interventions/:interventionId" element={<AdminInterventionDetail />} />
              <Route path="demandes-site" element={<AdminContactRequests />} />
              <Route path="compte" element={<ChangePasswordForm />} />
            </Route>

            {/* Espace Client */}
            <Route path="/espace-client" element={<ProtectedRoute allow={['client']}><ClientLayout /></ProtectedRoute>}>
              <Route index element={<ClientDashboard />} />
              <Route path="nouvelle-demande" element={<ClientNewRequest />} />
              <Route path="demande/:interventionId" element={<ClientRequestDetail />} />
              <Route path="compte" element={<ChangePasswordForm />} />
            </Route>

            {/* Site vitrine public */}
            <Route path="/*" element={<PublicSite />} />
          </Routes>
          <Toaster position="top-right" />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
